import { render, staticRenderFns } from "./UploadWoWExe.vue?vue&type=template&id=312dd695&scoped=true&"
import script from "./UploadWoWExe.vue?vue&type=script&lang=ts&"
export * from "./UploadWoWExe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312dd695",
  null
  
)

export default component.exports